export const countriesListEU: { id: string; label: string }[] = [
  { label: 'Polska', id: 'PL' },
  { label: 'Austria', id: 'AT' },
  { label: 'Belgia', id: 'BE' },
  { label: 'Bułgaria', id: 'BG' },
  { label: 'Chorwacja', id: 'HR' },
  { label: 'Cypr', id: 'CY' },
  { label: 'Czechy', id: 'CZ' },
  { label: 'Dania', id: 'DK' },
  { label: 'Estonia', id: 'EE' },
  { label: 'Finlandia', id: 'FI' },
  { label: 'Francja', id: 'FR' },
  { label: 'Grecja', id: 'GR' },
  { label: 'Hiszpania', id: 'ES' },
  { label: 'Holandia', id: 'NL' },
  { label: 'Irlandia', id: 'IE' },
  { label: 'Litwa', id: 'LT' },
  { label: 'Luksemburg', id: 'LU' },
  { label: 'Łotwa', id: 'LV' },
  { label: 'Malta', id: 'MT' },
  { label: 'Niemcy', id: 'DE' },
  { label: 'Portugalia', id: 'PT' },
  { label: 'Rumunia', id: 'RO' },
  { label: 'Słowacja', id: 'SK' },
  { label: 'Słowenia', id: 'SI' },
  { label: 'Szwecja', id: 'SE' },
  { label: 'Węgry', id: 'HU' },
  { label: 'Włochy', id: 'IT' },
];

export default countriesListEU;
